import { removeHtmlLineBreaks } from './text.service';

export enum HeadlineVariant {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  Text = 'Text',
}

type HeadlineTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'span';

export const headlineToPrefixMap: { [key in HeadlineVariant]: string } = {
  [HeadlineVariant.H1]: '#',
  [HeadlineVariant.H2]: '##',
  [HeadlineVariant.H3]: '###',
  [HeadlineVariant.H4]: '####',
  [HeadlineVariant.H5]: '#####',
  [HeadlineVariant.Text]: '',
};

export const headlineToTagMap: { [key in HeadlineVariant]: HeadlineTag } = {
  [HeadlineVariant.H1]: 'h1',
  [HeadlineVariant.H2]: 'h2',
  [HeadlineVariant.H3]: 'h3',
  [HeadlineVariant.H4]: 'h4',
  [HeadlineVariant.H5]: 'h5',
  [HeadlineVariant.Text]: 'span',
};

export const headlineToChildHeadlineMap: { [key in HeadlineVariant]: HeadlineVariant } = {
  [HeadlineVariant.H1]: HeadlineVariant.H2,
  [HeadlineVariant.H2]: HeadlineVariant.H3,
  [HeadlineVariant.H3]: HeadlineVariant.H4,
  [HeadlineVariant.H4]: HeadlineVariant.H5,
  [HeadlineVariant.H5]: HeadlineVariant.Text,
  [HeadlineVariant.Text]: HeadlineVariant.Text,
};

export interface ParsedHeadline {
  variant: HeadlineVariant;
  text: string;
  html: string;
  tag: HeadlineTag;
}

export function parseHeadline(value: string): ParsedHeadline {
  let _value = value;

  let variant: HeadlineVariant = HeadlineVariant.Text;

  try {
    const [foundPrefix, ...remainingText] = value.split(' ');

    Object.entries(headlineToPrefixMap).forEach(([entryVariant, prefix]) => {
      if (prefix === foundPrefix) {
        variant = entryVariant as HeadlineVariant;
        _value = remainingText.join(' ');
      }
    });
  } catch (e) {
    console.error(`Failed to detect headline variant: ${(e as Error).message}`);
  }

  const html: string = _value;
  const text: string = removeHtmlLineBreaks(html);
  const tag: HeadlineTag = headlineToTagMap[variant];

  return { html, tag, text, variant };
}

export function stringifyHeadline(parsedHeadline: ParsedHeadline): string {
  return `${headlineToPrefixMap[parsedHeadline.variant]} ${parsedHeadline.text}`;
}
